import { Coupon } from '@/models/Coupon'
import { get } from '@/utils/axios'

const fetchAllCoupons = async (buyerPhoneNumber?: string) => {
  try {
    return await get<Coupon[]>('/user/v1/coupons', {
      ...(buyerPhoneNumber && {
        buyer_phone_number: buyerPhoneNumber,
      }),
    })
  } catch (e) {
    console.error(e)
    return []
  }
}

export default fetchAllCoupons
